import { CORE_URL } from '../../../helpers/env'

export const GET_MANUFACTURERS = 'GET_MANUFACTURERS'
export const GET_MANUFACTURERS_SUCCESS = 'GET_MANUFACTURERS_SUCCESS'
export const GET_MANUFACTURERS_FAILED = 'GET_MANUFACTURERS_FAILED'
export const SET_MANUFACTURER_FILTER = 'SET_MANUFACTURER_FILTER'

export const API_URL = CORE_URL
